import { createAsyncAction } from "../actionCreators";
import { API, camelize } from "@thenounproject/lingo-core";

type Args = {
  spaceId: number;
};

type Result = {
  authorizationUrl: string;
};

const [useInitiateFigmaOAuth, initiateFigmaOAuth] = createAsyncAction(
  "figma/initiateFigmaOAuth",
  async ({ spaceId }: Args) => {
    const res = await API.call<{ authorization_url: string }>({
      endpoint: `spaces/${spaceId}/figma/oauth/initiate`,
      method: "POST",
    });
    return { result: camelize(res.result) as Result };
  }
);

export default useInitiateFigmaOAuth;
export { initiateFigmaOAuth };
